import React from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
if (container) {
  try {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error("Error rendering app:", error);
    // Safely render error without innerHTML to prevent XSS
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'padding: 20px; color: red;';
    const h1 = document.createElement('h1');
    h1.textContent = 'Error';
    const pre = document.createElement('pre');
    pre.textContent = error.message;
    errorDiv.appendChild(h1);
    errorDiv.appendChild(pre);
    container.appendChild(errorDiv);
  }
} else {
  console.error("Root element not found!");
}
